export const DirectorioItem = [
      {
       "area": "Despacho de la Oficialía Mayor",
       "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
       "Telefono": "7717176000 Ext. 6283",
       "correo":"oficialiamayor@hidalgo.gob.mx"
      },
      {
        "area": "Coordinación General de la Oficialía Mayor",
        "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6283",
        "correo":"oficialiamayor@hidalgo.gob.mx"
     },
     {
        "area": "Dirección General de Asuntos Jurídicos",
        "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6856",
        "correo":"juridico_om@hidalgo.gob.mx"
     },

     {
      "area": "Dirección General de Seguimiento a Procesos de Fiscalización y Auditoría",
      "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
      "Telefono": "7717176000 Ext. 6436",
      "correo":"dgspfa@hidalgo.gob.mx"
   },
     {
        "area": "Dirección General de Organización y Rediseño Institucional",
        "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6880",
        "correo":"redisenoinstitucionalom@hidalgo.gob.mx"
     },
     {
        "area": "Dirección General de Administración",
        "lugar":"Palacio de Gobierno, 3er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6291",
        "correo":"comunicacion.dga@hidalgo.gob.mx"
     },
     {
        "area": "Dirección General de Compras Públicas",
        "lugar":"Belisario Dominguez No. 901, Col. Jardín Colón, C.P. 42000 Pachuca de Soto, Hidalgo",
       
        "correo":"compraspublicas@hidalgo.gob.mx"
     },
     {
      "area": "Dirección General de Servicios Generales",
      "lugar":"Vicente Segura No. 201, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
      "Telefono": "7717176000 Ext. 2130",
      "correo":"dgrmys.despacho@hidalgo.gob.mx"
   },
     {
        "area": "Dirección General de Recursos Materiales",
        "lugar":"Vicente Segura No. 201, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 2120",
        "correo":"-"
     },
     {
        "area": "Dirección General de Recursos Humanos",
        "lugar":"Palacio de Gobierno, Planta Baja, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6287, 6776 y 6279",
        "correo":"dgrecursoshumanos@hidalgo.gob.mx"
     },
     {
        "area": "Dirección General de Patrimonio Inmobiliario",
        "lugar":"Calle Valladolid No. 100-B, Col. ExHacienda de Guadalupe C.P. 42050 Pachuca de Soto, Hidalgo",
        "Telefono": "7717132328",
        "correo":"dgpi@hidalgo.gob.mx"
     },
     {
        "area": "Dirección General de Innovación Gubernamental",
        "lugar":"Palacio de Gobierno, 1er. Piso, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717176000 Ext. 6256",
        "correo":"cas@hidalgo.gob.mx"
     },
     {
        "area": "Archivo General del Estado",
        "lugar":"Calle Hidalgo No. 807, Col. Centro C.P. 42000 Pachuca de Soto, Hidalgo",
        "Telefono": "7717150347, 7176000 Ext. 2387",
        "correo":"archivo_gral@hidalgo.gob.mx"
     },
  
]